import React, { Component } from 'react';

import { Row, Col, InputGroup } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CustomDatePicker from '../components/CommonDatePicker';

/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/

import CommonButton from '../components/CommonButton';

class SearchTypeAStudentImportFile extends Component {

    render = () => {
        let props = this.props;

        let { onInputChange, onSearch } = props;

        let { Action, Searchs, InputGroup: InputGroups, Masterbase, Operation } = props;

        let { file_type, name, start_import_date, end_import_date, status } = Searchs; 

        if(Operation.Search !== true) return null;

        return (
            <>
                <Row>
                    <Col md={6}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text className="input-group-text">{file_type.label}</InputGroup.Text>
                                <CommonSelect
                                    element="Searchs"
                                    input={file_type}
                                    option={{source: 'options', section: 'category', item: 'type_a_student_import_file_type'}}
                                    hr={false}
                                    callback={(e, element) => onInputChange(e, element)} 
                                />
                        </InputGroup>
                    </Col>
                    <Col md={4}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text className="input-group-text">{name.label}</InputGroup.Text>
                                <CommonInput
                                    element="Searchs"
                                    input={name}
                                    hr={false}
                                    callback={(e, element) => onInputChange(e, element)} 
                                />
                        </InputGroup>
                    </Col>                    
                </Row>
                <Row>
                    <Col md={3}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text className="input-group-text">เริ่ม</InputGroup.Text>
                            <div className="form-control p-0 border-0">
                                <CustomDatePicker 
                                    element="Searchs"
                                    input={start_import_date}
                                    hr={false}
                                    callback={(e, element) => onInputChange(e, element)} 
                                />
                            </div>
                        </InputGroup>
                    </Col>
                    <Col md={3}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text className="input-group-text">ถึง</InputGroup.Text>
                            <div className="form-control p-0 border-0">
                                <CustomDatePicker 
                                    element="Searchs"
                                    input={end_import_date}
                                    hr={false}
                                    callback={(e, element) => onInputChange(e, element)} 
                                />
                            </div>
                        </InputGroup>
                    </Col>
                    <Col md={3}>
                        <InputGroup className="mb-3">
                            <InputGroup.Text className="input-group-text">{status.label}</InputGroup.Text>
                            <CommonSelect
                                element="Searchs"
                                input={status}
                                option={{source: 'options', section: 'status', item: 'type_a_student_import_file'}}
                                hr={false}
                                callback={(e, element) => onInputChange(e, element)} 
                            />
                        </InputGroup>
                    </Col>
                    <Col md={3}>
                        <CommonButton 
                            task="search" 
                            disabled={Action.Loading.search ? true : false}
                            callback={(e) => onSearch(e)} 
                        />
                    </Col>
                </Row>                
            </>
        )
    }
}

export default SearchTypeAStudentImportFile;